import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_index/cuenta/')({
  beforeLoad: () => {
    throw redirect({
      to: '/cuenta/perfil',
    })
  },
  staticData: {
    metaRoute: {
      hidden: true, 
    }
  }
})
